var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.942,
    height: 19.942,
    viewBox: "0 0 19.942 19.942",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ef5658;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.971,0A9.971,9.971,0,1,1,0,9.971,9.971,9.971,0,0,1,9.971,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.862,6.383l-1.9,1.9V2.833a.828.828,0,1,0-1.655,0V8.287l-1.9-1.9A.831.831,0,1,0,7.241,7.559l3.311,3.311a.856.856,0,0,0,1.175,0l3.311-3.311a.831.831,0,0,0-1.175-1.175Z",
    transform: "translate(-1.107 2.995)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.2efddd3c7999a56bc8eb48e743ba0466.svg";
export { ForwardRef as ReactComponent };